import * as yup from 'yup';

export const abweichenderHalterSchema = yup.object({
  isHalterAbweichend: yup.boolean().default(false),
  typ: yup.string().default(''),
});
